import styled from 'styled-components';
import ds from 'designsystem';

const LogoWrapper = styled.div`
  ${({ fixed }) => (fixed ? `
    position: fixed;
    z-index: 1000;`
    : 'position: relative;'
  )}
  ${({ absolute }) => (absolute ? 'position: absolute; z-index: 500;' : '')}
  ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor}` : '')};
  display: flex;
  align-items: center;
  top: 0;
  height: ${ds.get('navSection.navHeight')};
  padding: ${ds.get('metrics.xs')} 0;
  
  ${({ alignSelf }) => (alignSelf ? `align-self: ${alignSelf};` : '')}
`;

export default LogoWrapper;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Logo/LogoWrapper.jsx